import React from 'react';
import { useMatchMedia } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { employerIds } from '@src/constants/employerResources';
import styles from './HeroBanner.module.scss';

export const HeroBanner: React.FC = () => {
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const employer = user?.employer || '';
	const isHeroImageVisible = useMatchMedia('(max-width: 1200px)');

	const getSubText = () => {
		if (user?.employer_uuid === employerIds.jpmc) {
			return 'Explore another way to fund your education at schools not offered through the Direct Payment Program Network.';
		}

		return `Explore another way to fund your education at schools not offered through the ${employer ? `${employer} ` : ''}Guild Certified Network.`;
	};

	return (
		<div className={styles.hero}>
			<div className={styles.heroText}>
				<Typography className={styles.heroHeading} testid='hero-heading' variant='h1'>
					Discover more ways to go back to school with the Direct Payment Program.
				</Typography>
				<Typography className={styles.heroTitle} testid='hero-title' variant='title3'>
					{getSubText()}
				</Typography>
			</div>
			{!isHeroImageVisible ? (
				<div>
					<img
						alt=''
						className={styles.heroImage}
						data-testid='hero-image'
						src='https://imgix.guildeducation.com/catalog-frontend/affiliates-hero-crop.png'
					/>
				</div>
			) : null}
		</div>
	);
};
